import { CheckCircle2, AlertTriangle, CircleDashed } from "lucide-react";
import { Location, ReadinessState } from "@/bryntum-lib/models/Location";
import { cn } from "@/modern/utils";

// ─── Badge config ─────────────────────────────────────────────────────────────

const READINESS_CONFIG: Record<
  ReadinessState,
  { label: string; cls: string; Icon: typeof CheckCircle2 }
> = {
  field_ready: {
    label: "Field-Ready",
    cls: "bg-success/15 text-success border-success/30",
    Icon: CheckCircle2,
  },
  partial: {
    label: "Partial",
    cls: "bg-amber-500/15 text-amber-500 border-amber-500/30",
    Icon: AlertTriangle,
  },
  thin: {
    label: "Thin",
    cls: "bg-muted text-muted-foreground border-border",
    Icon: CircleDashed,
  },
};

// ─── Component ────────────────────────────────────────────────────────────────

interface LocationReadinessBadgeProps {
  locationRecord: Location | null | undefined;
  className?: string;
}

export const LocationReadinessBadge = ({ locationRecord, className }: LocationReadinessBadgeProps) => {
  if (!locationRecord) return null;

  const state: ReadinessState = locationRecord.readinessState ?? "thin";
  const { label, cls, Icon } = READINESS_CONFIG[state];

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium",
        cls,
        className
      )}
    >
      <Icon className="size-3.5" />
      {label}
    </span>
  );
};
